<template>
    <b-container>      
        <a href="/admin/system-message/new" class="btn btn-secondary float-right">Add
        System Message</a>
        <h1>System Messages</h1>
      <div v-if="list.length > 0">
        <b-table striped hovaer :fields="fields" :items="list">
          <template #cell(actions)="data">
          <div class="text-right" style="white-space: nowrap;">
            <a :href="`/admin/system-message/${ data.item.id }/edit`">Edit</a>
          </div>
        </template>
        </b-table>
    </div>
    </b-container>
</template>
<script>


import MessageDataService from "@/services/MessageDataService";
// import SimpleVueValidation from 'simple-vue-validator';
// const Validator = SimpleVueValidation.Validator;
export default {
data() {
  return {
    list: [],
    update: false,
    created: false,
    fields: [
      { key: "subject", label: "Subject" },
      { key: "created_at", label: "Date Created" },
      { key: "published_at", label: "Date Published" },
      { key: "actions", label: "Actions" },
    ],
  };
},
created() {
  MessageDataService.getAll().then((res) => {
    this.list = res.data;
  });

},
}


</script>